import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// JSX -> HTML junto com JS
// Transpilar (transformar em um js válido)

// -> componentização
// -> props
// -> state
// -> cliclo de vida

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);
